export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
    visible: !that.disabled,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_pdProcessDictStep') || '工序',
    field: 'v_pdProcessDictStep',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_techName') || '工艺',
    field: 'techName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_techDesc') || '工艺要求',
    field: 'techDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_techChargeUnit') || '计价单位',
    field: 'techChargeUnit',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_unitPrice') || '单价',
    field: 'unitPrice',
    align: 'center',
    width: 100,
    formatter: ({ row }) => {
      const { unitPrice: value } = row
      return that.format(value)
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_qty') || '数量',
    field: 'qty',
    align: 'center',
    width: 100,
    formatter: ({ row }) => {
      const { qty: value } = row
      return that.format(value)
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_subPrice') || '小计',
    field: 'subPrice',
    align: 'center',
    width: 100,
    formatter: ({ row }) => {
      const { subPrice: value } = row
      return that.format(value)
    },
    showHeaderOverflow: true,
  },
]
